import { Outlet } from 'react-router-dom';

export const PersistentComponent = () => {
    return <Outlet />;
};
